import * as AppAr from "../assets/i18n/ar.json";
import * as AppEn from "../assets/i18n/en.json";

export { AppEn, AppAr };
